import type { ReactNode } from 'react';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/shared/ui/inputs/Input';
import { cn } from '@/shared/utils/cn';

type Props = {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  children?: ReactNode;
  className?: string;
  /** Force-hide the search input even if `onSearchChange` is provided. */
  hideSearch?: boolean;
};

export const FilterBar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  children,
  className,
  hideSearch = false,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      {!hideSearch && onSearchChange && (
        <div className="w-full sm:w-72">
          <Input
            value={searchValue ?? ''}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder ?? t('ui.searchPlaceholder')}
            prefix={<Search className="h-4 w-4" />}
          />
        </div>
      )}
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
};
